import React from 'react';
import {Avatar, Button, ButtonGroup, ListItem, ListItemAvatar, ListItemText, Typography} from "@mui/material";
import _ from "lodash";
import { LoadingButton } from '@mui/lab';

const getPluginIcon = (slug, enabled) => {
    const basePath = "/images/icons";
    const suffix = enabled ? "color" : "bw";
    return `${basePath}/${slug}-${suffix}.svg`;
}

const PluginListItem = (props) => {
    return (
        <ListItem sx={{p: theme => theme.spacing(1, 0)}}>
            <ListItemAvatar>
                <Avatar
                    src={getPluginIcon(props.plugin.slug, props.enabled)}
                    alt={props.plugin.name}
                    sx={{
                    boxShadow: 2,
                    bgcolor: "white",
                    width: 48,
                    height: 48,
                    p: 1
                    }}
                >
                    {props.plugin.name[0]} {/* fallback si no hay logo */}
                </Avatar>
            </ListItemAvatar>
            
            <ListItemText
                primary={
                    <Typography 
                        variant="h6"
                        sx={{
                            pr: 2,
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            maxWidth: "70%"
                        }}
                        >
                        {props.plugin.name}
                    </Typography>
                }
            />
            <ButtonGroup>
                {props.enableConfigButton === true &&
                    <Button
                        variant='contained'
                        size='small'
                        color='primary'
                        onClick={() => props.onConfig(props.plugin)}>
                        Configurar
                    </Button>
                }
                <LoadingButton
                    loading={props.inLoading}
                    variant="contained"
                    color={props.enabled ? "success" : "warning" }
                    size='small'
                    sx={{minWidth: 140}}
                    loadingPosition="end"
                    disabled={props.inLoading}
                    onClick={() => props.onToggle(props.plugin)}>
                        {props.enabled ? props.onText : props.offText}
                </LoadingButton>
            </ButtonGroup>
        </ListItem>
    );
};

export default PluginListItem;